import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  Input,
  Select,
  Modal,
  Popconfirm,
  Row,
  Col,
  Radio,
  Checkbox,
  DatePicker,
  Space,
} from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";
import service from "../../../services/citizenScienceLookupService";
import commonLookupService from "src/services/commonLookupService";
import util from "../../../utils/functions/custom";
import { recordError } from "../../../utils/logService";
import { Messages, Notify } from "../../../services/custom/Messages";
import dayjs from 'dayjs';

import {
  openNotification,
  booleanEnum
} from "@seims/shared";

const EditProjectDetail = ({
  data,
  visible,
  onCancel,
  onModalSubmit,
}) => {
  const [scienceFields, setScienceFields] = useState([]);
  const [selectedField, setSelectedField] = useState(data?.scienceFields?.key);
  const [scienceDomains, setScienceDomains] = useState([]);
  const [plannedDisseminations, setPlannedDisseminations] = useState([]);
  // const [showOtherRoles, setShowOtherRoles] = useState(false);
  const [booleanOptions, setBooleanOption] = useState([
    { value: "Yes", key: true },
    { value: "No", key: false },
  ]);
  const [isScienceShop, setIsScienceShop] = useState(false);
  const [selectedScienceShop, setSelectedScienceShop] = useState("");
  const [selectedScienceDomains, setSelectedScienceDomains] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [district, setDistrict] = useState();
  const [districts, setDistricts] = useState([]);
  const [towns, setTowns] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const dateFormat = "YYYY-MM-DD";
  const { TextArea } = Input;
  const { Option } = Select;
  const [form] = Form.useForm();
  const formName = "EditProjectLeadForm";

  const formItemLayout = {
    labelCol: {
      span: 18,
    },
    wrapperCol: {
      span: 20,
    },
    layout: "vertical",
  };
  const [value, setValue] = useState(1);

  useEffect(() => {
    getScienceFields();
    getprovinceData();
    getDisseminationApproaches();
  }, []);

  useEffect(() => {
    loadProjectData();
  }, [provinces.length > 0]);

  const onNameBlur = (e) => {
    const { value, name } = e.target;
    const textValue = util.toPascalText(value);
    form.setFieldsValue({ [name]: textValue });
  };
  const loadProjectData = () => {
      if (!util.isEmpty(data)) {
      const _disseminations = data.disseminations?.map((d) => d.key);
      onChangeScienceFields(data.projectProfile.scienceField);
      form.setFieldsValue({
        id: data.id,
        name: data.projectProfile.name,
        description: data.projectProfile.description,
        startDate: dayjs(data.projectProfile.startDate),
        endDate: dayjs(data.projectProfile.endDate),
        initiallyCitizenScience: data.projectProfile.initiallyCitizenScience,
        scienceShopInitiative: data.projectProfile.scienceShopInitiative,
        scienceField: data.scienceFields,
        scienceDomains: data.scienceDomains,
        locations: data.locations,
        plannedDisseminations: _disseminations,
        // otherDissemination: data.projectProfile.otherDissemination,
      });
       getScienceDomains(data.scienceFields.key);
      let sDomains = [];
      data.scienceDomains.forEach((d) => {
        sDomains.push(d.key);
      })
      setSelectedScienceDomains(sDomains);
      data.locations.forEach((item, index) => {
        const selectedProvince = provinces?.find(
          (c) => c.value === item.province.value
        );

        if (selectedProvince?.districts.length > 0) {
          const selectedDistrict = selectedProvince?.districts?.find(
            (c) => c.value === item.district.value
          );
          setDistricts((prev) => ({
            ...prev,
            [index]: selectedProvince?.districts,
          }));
          setTowns((prev) => ({ ...prev, [index]: selectedDistrict?.towns }));
        }
      });
      // if (
      //   data.projectProfile.otherDissemination !== null &&
      //   data.projectProfile.otherDissemination !== undefined
      // ) {
      //   setShowOtherRoles(true);
      // }
    }
  };

  const transformKeyValue = (keyValues) => {
    return keyValues?.map((d) => {
      return {
        label: d.value,
        value: d.key,
        key: d.key,
      };
    });
  };

  const getScienceFields = async () => {
    try {
      const response = await service.getScienceFields();
      if (response && response.status === 200) {
        const { data } = response;
        setScienceFields(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getDisseminationApproaches = async () => {
    try {
      const response = await service.getDisseminationApproaches();
      if (response && response.status === 200) {
        const { data } = response;
        const treeData = transformKeyValue(data);
        setPlannedDisseminations(treeData);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getprovinceData = async () => {
    try {
      const response = await commonLookupService.getProvincesDistrictTowns();
      if (response && response.status === 200) {
        const { data } = response;
        setProvinces(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getScienceDomains = async (selectedField) => {
    setSelectedScienceDomains([]);
    try {
      const response = await service.getScienceDomainsByFields(selectedField);
      if (response && response.status === 200) {
        const { data } = response;
        setScienceDomains(data);
      }
    } catch (error) {
      recordError(error);
    }
  }

  const onPopCancel = () => {
    onCancel();
    form.resetFields();
    setDisabled(true);
    loadProjectData();
  };

  const Confirm = () => {
    onCancel();
    form.resetFields();
  };

  const handleProvinceChange = (value, namePath) => {
    const selectedProvince = provinces.find(
      (record) => record.value === value
    );

    const currentLocation = form.getFieldValue(["locations", namePath]);
    form.setFieldsValue({
      locations: {
        ...currentLocation,
        [namePath]: {
          province: {
            key: selectedProvince.key,
            value: selectedProvince.value,
          },
          district: undefined,
          town: undefined,
        },
      },
    });
    setDistricts((prev) => ({
      ...prev,
      [namePath]: selectedProvince?.districts,
    }));
    setTowns((prev) => ({ ...prev, [namePath]: [] }));
  };

  const handleDistrictChange = (value, namePath) => {
    const currentLocation = form.getFieldValue(["locations", namePath]);
    const selectedDistrict = districts[namePath].find(
      (district) => district.value === value
    );

    form.setFieldsValue({
      locations: {
        ...currentLocation,
        [namePath]: {
          ...currentLocation[namePath],
          district: {
            key: selectedDistrict.key,
            value: selectedDistrict.value,
          },
          town: undefined,
        },
      },
    });
    setTowns((prev) => ({ ...prev, [namePath]: selectedDistrict.towns }));
  };

  const handleCityChange = (value, namePath) => {
    const selectedTown = towns[namePath].find((c) => c.value === value);
    const currentLocation = form.getFieldValue(["locations", namePath]);

    form.setFieldsValue({
      locations: {
        ...currentLocation,
        [namePath]: {
          ...currentLocation[namePath],
          town: { key: selectedTown.key, value: selectedTown.value },
        },
      },
    });
  };

  const onChangeScienceFields = async (selectedValue) => {
    const _field = scienceFields.find(
      (c) => c.value === selectedValue
    );
    if (_field !== undefined) {
      form.setFieldsValue({ scienceField: _field });
      form.resetFields(["scienceDomains"]);
      getScienceDomains(_field.key);
      setSelectedField(_field.key)

    }
  };

  const onChangeScienceDomain = (selectedValue) => {
    const selectedDomain = scienceDomains.find(
      (c) => c.key === parseInt(selectedValue)
    );
    if (selectedDomain !== undefined) {
      // const selDomain = selectedScienceDomains.find(
      //   (c) => c.key === parseInt(selectedValue)
      // );
      // if(selDomain === undefined){
      setSelectedScienceDomains([
        ...selectedScienceDomains,
        { key: selectedDomain.key, value: selectedDomain.value },
      ]);

      form.setFieldsValue({ scienceDomains: selectedScienceDomains });

    }
    // }
  };

  const onChangeDomain = (selectedValues) => {
    //setSelectedScienceDomains(selectedValues);
    let domains = [];
    selectedValues.forEach((value) => {
      var domain = scienceDomains.find((scienceDomain) => scienceDomain.value === value);
      if (domain !== undefined) {
        domains.push(parseInt(domain.key));
      } else {
        domains.push(parseInt(value));
      };
    });
    setSelectedScienceDomains(domains);
  };

  const checkDate = () => {
    if (

      form.getFieldsValue().startDate !== undefined &&
      form.getFieldsValue().endDate
    ) {
      const startDate = new Date(
        dayjs(form.getFieldsValue().startDate).format(dateFormat)

      );
      const endDate = new Date(
        dayjs(form.getFieldsValue().endDate).format(dateFormat)
      );
      if (startDate > endDate) {
        var msg = util.parseMessage(
          Messages.DATE_ERROR,
          "Start date must not be later than end date"
        );
        openNotification("Project date", msg, Notify.ERROR);
      }
    }
  };

  const onChangeRoles = (selectedValue) => {
    const selectedOptions = plannedDisseminations?.filter((c) =>
      selectedValue.includes(c.key)
    );
    // const otherSelected = selectedOptions.some((c) => c.label === "Other");

    // if (otherSelected) {
    //   setShowOtherRoles(otherSelected);
    // } else {
    //   setShowOtherRoles(otherSelected);
    // }
  };

  const onRemove = (name) => {
    const currentValues = form.getFieldValue("locations") || [];
    const updatedValues = currentValues.filter((_, index) => index !== name);
    form.setFieldsValue({ locations: updatedValues });
  };

  const onSubmit = async (values) => {
    try {
      let locations = [];
       values.locations.forEach((location) => {
        locations.push({
          town: location.town?.key ?? 0,
          district: location.district.key,
          province: location.province.key,
        });
      });

      const uniqueLocations = locations.filter((o, index, arr) =>
        arr.findIndex(item => JSON.stringify(item) === JSON.stringify(o)) === index
      );

      if (uniqueLocations.length < locations.length) {
        const msg = "Duplicate locations found, please add unique locations";
        openNotification("Project Location", msg, Notify.ERROR);
        return;
      }
      const projectData = {
        id: parseInt(data.id),
        name: values.name,
        description: values.description,
        startDate: dayjs(values.startDate),
        endDate: dayjs(values.endDate),
        initiallyCitizenScience: values.initiallyCitizenScience,
        scienceShopInitiative: values.scienceShopInitiative,
        scienceField: values.scienceField.key,
        scienceDomains: selectedScienceDomains,
        locations: locations,
        dissemination: values.plannedDisseminations,
        address:values.locations,
        // otherDissemination:
        //   values.otherDissemination === undefined
        //     ? null
        //     : values.otherDissemination,
      };
      onModalSubmit(projectData);
      let domains = [];
      selectedScienceDomains.forEach((domain) => {
        var d = scienceDomains.find((scienceDomain) => scienceDomain.key === domain);
        if (domain !== undefined) {
          domains.push(d);
        }
      })
      let disseminations = [];
       values.plannedDisseminations.forEach((dissemination) => {
        var d = plannedDisseminations.find((planned) => planned.key === dissemination);
        if (disseminations !== undefined) {
          disseminations.push(d);
        }
      })
      data.projectProfile.name = values.name;
      data.projectProfile.description = values.description;
      data.scienceFields = values.scienceField;
      data.scienceField = values.scienceField.key;
      data.projectProfile.scienceField = values.scienceField.key;
      data.scienceDomains = domains;
      data.disseminations = disseminations;
      data.projectProfile.initiallyCitizenScience = values.initiallyCitizenScience;
      data.projectProfile.scienceShopInitiative = values.scienceShopInitiative;
      data.locations = values.locations;

      loadProjectData();
    } catch (error) {
      recordError(error);
    }
  };

  const onChangeScienceOption = (e) => {
    const { value: selected } = e.target;
    const selectedLocality = booleanOptions.find(
      (record) => record.key === selected
    );

    if (selectedLocality.value == booleanEnum.LOCAL) {
      setIsScienceShop(true);
    } else {
      setIsScienceShop(false);
    }

    setSelectedScienceShop(selected);
  };

  return (
    <Modal
      title="Project Details - Edit"
      open={visible}
      closable={false}
      keyboard={false}
      maskClosable={false}
      onCancel={onCancel}
      width={1200}
      footer={[
        <div className="modal-footer-buttons">
          <Popconfirm
            key="20"
            title="Are you sure you want to cancel...you will lose all info entered?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => Confirm()}
            onCancel={onPopCancel}
            disabled={disabled}
          >
            <Button
              onMouseUp={() => onPopCancel()}
              style={{ marginLeft: 10 }}
            >
              Cancel
            </Button>
          </Popconfirm>
          <Button
            type="primary"
            htmlType="submit"
            onSubmit={onSubmit}
            form={formName}
          >
            Update
          </Button>
        </div>,
      ]}
    >
      <Form
        {...formItemLayout}
        disabled={false}
        scrollToFirstError
        form={form}
        name={formName}
        onFinish={onSubmit}
      >
        <Row>
          <Col xs={24} sm={8} md={20}>
            <Form.Item
              name="name"
              label="Title"
              rules={[
                {
                  required: true,
                  message: "Please enter project title",
                },
                {
                  required: true,
                  min: 3,
                  message: "Please enter a longer title",
                },
              ]}
            >
              <Input
                name="projectTitle"
                onBlur={onNameBlur}
                showCount
                maxLength={255}
                minLength={3}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={20}>
            <Form.Item
              name="description"
              label="Description"
              rules={[
                {
                  required: true,
                  message: "Please enter project description",
                },
                {
                  required: true,
                  min: 5,
                  message: "Please enter a longer description",
                },
              ]}
            >
              <TextArea
                name="description"
                rows={4}
                placeholder="Please add project description here..."
                showCount
                maxLength={1500}
                minLength={5}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} sm={8} md={8}>
            <Form.Item
              name="scienceField"
              label="Science Discipline"
              rules={[
                {
                  required: true,
                  message: "Please select science discipline",
                },
              ]}
            >
              <Select onChange={onChangeScienceFields}>
                {scienceFields.map((field) => (
                  <Option key={field.key} value={field.value}>
                    {field.value}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={8} md={8}>
            <Form.Item
              name="scienceDomains"
              label="Science Fields"
              rules={[
                {
                  required: true,
                  message: "Please select science fields",
                },
              ]}
            >
              <Select
                mode="multiple"
                allowClear
                style={{ width: "100%" }}
                placeholder="Please select"
                // onSelect={onChangeScienceDomain}
                onChange={onChangeDomain}
              >
                {scienceDomains.map((domain) => (
                  <Option key={domain.key}>{domain.value}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col xs={24} sm={8} md={8}>
            <Form.Item
              name="startDate"
              label="Planned Start Date"
              rules={[
                {
                  required: false,
                  message: "Please select date",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format={dateFormat}
                onChange={checkDate}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8} md={8}>
            <Form.Item
              name="endDate"
              label="Planned End Date"
              rules={[
                {
                  required: false,
                  message: "Please select date",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format={dateFormat}
                onChange={checkDate}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col xs={24} sm={24} md={24}>
            <Form.Item
              style={{ fontWeight: "bold" }}
              name="locations"
              label="Location"
              rules={[
                {
                  required: true,
                  message: "Please select Location values",
                },
              ]}
            >
              <p style={{ textAlign: "left", fontWeight: "normal" }}>
                Where is this project located?
              </p>
              <Form.List name="locations">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(
                      ({ key, field, name, index, ...restField }) => (
                        <Space
                          key={key}
                          style={{
                            display: "flex",
                            marginBottom: 8,
                            width: "100%",
                          }}
                          align="baseline"
                        >
                          <Form.Item
                            {...restField}
                            name={[name, "province"]}
                            label="Province"
                            rules={[
                              {
                                required: true,
                                message: "Please select Province",
                              },
                            ]}
                          >
                            <Select
                              onChange={(value) =>
                                handleProvinceChange(value, [name])
                              }
                            >
                              {provinces?.map((option) => (
                                <Option key={option.key} value={option.value}>
                                  {option.value}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            name={[name, "district"]}
                            label="District"
                            rules={[
                              {
                                required: true,
                                message: "Please select District",
                              },
                            ]}
                          >
                            <Select
                              value={district}
                              onChange={(value) =>
                                handleDistrictChange(value, [name])
                              }
                            >
                              {(districts[name] || []).map((dist) => (
                                <Option key={dist.key} value={dist.value}>
                                  {dist.value}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            name={[name, "town"]}
                            label="Nearest Town"
                          >
                            <Select
                              onChange={(value) =>
                                handleCityChange(value, [name])
                              }
                            >
                              {(towns[name] || []).map((town) => (
                                <Option key={town.key} value={town.value}>
                                  {town.value}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                          <MinusCircleOutlined
                            //   onClick={() => {remove(name); onRemove(name);}}
                            onClick={() => onRemove(name)}
                          />
                        </Space>
                      )
                    )}
                    <Form.Item>
                      <Button type="dashed" onClick={() => add()} block>
                        Add Location
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col xs={24} md={24} sm={24}>
            <Form.Item
              name="plannedDisseminations"
              label="Planned Research Dissemination Approach"
              rules={[
                {
                  required: true,
                  message: "Please select a dissemination approach",
                },
              ]}
            >
              <Checkbox.Group
                onChange={onChangeRoles}
                options={plannedDisseminations}
                style={{ display: "flex", flexDirection: "column" }}
              />
            </Form.Item>

            {/* {showOtherRoles && (
                <Form.Item
                  name="otherDissemination"
                  label="Project Roles"
                  rules={[
                    {
                      required: true,
                      message: "Please provide other role",
                    },
                  ]}
                >
                  <Row>
                    <Col xs={8} md={8} sm={8}>
                      <Input name="otherDissemination" />
                    </Col>
                  </Row>
                </Form.Item>
              )} */}
          </Col>
        </Row>
        <Row>
          <Col xs={16} md={16} sm={16}>
            <Form.Item
              name="initiallyCitizenScience"
              label="Was this project conceptualised as Citizen Science project from the beginning?"
              rules={[
                {
                  required: true,
                  message: "Please choose an option",
                },
              ]}
            >
              <Radio.Group
                value={value}
                style={{ float: "left", width: "30px", height: "30px" }}
              >
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={24}>
            <Form.Item
              name="scienceShopInitiative"
              label="Is the facility at this institution a Science Shop?"
              rules={[
                {
                  required: true,
                  message: "Is it a science shop",
                },
              ]}
              wrapperCol={{ span: 6 }}
            >
              <Radio.Group
                onChange={onChangeScienceOption}
                value={selectedScienceShop}
                style={{ float: "left", width: "30px", height: "30px" }}
              >
                {booleanOptions.map((option) => (
                  <Radio key={option.key} value={option.key}>
                    {option.value}
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default EditProjectDetail;
